import BuilderSDK from '@builder.io/sdk';

import { BuilderConfig } from '../../types/Builder';
import { COLORS } from '../business-button/business-button.constants';
import BusinessHubImageHero, { BusinessHubImageHeroProps } from './business-hub-image-hero';

export const BusinessHubImageHeroBuilderConfig: BuilderSDK.Component = {
    name: 'Business Hub Image Hero',
    inputs: [
        {
            name: 'industryIcon',
            type: 'file',
        },
        {
            name: 'title',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'maxWithDescription',
            type: 'number',
        },
        {
            name: 'ctaText',
            type: 'text',
            defaultValue: '',
        },
        {
            name: 'ctaColor',
            type: 'string',
            enum: Object.values(COLORS),
            defaultValue: COLORS.MINT,
        },
        {
            name: 'ctaLink',
            type: 'url',
            defaultValue: '',
        },
        {
            name: 'background',
            type: 'object',
            subFields: [
                {
                    name: 'backgroundRightImage',
                    type: 'object',
                    subFields: [
                        { name: 'desktop', type: 'file' },
                        { name: 'mobile', type: 'file' },
                    ],
                },
                {
                    name: 'backgroundImage',
                    type: 'object',
                    subFields: [
                        { name: 'desktop', type: 'file' },
                        { name: 'mobile', type: 'file' },
                    ],
                },
                {
                    name: 'backgroundColor',
                    type: 'color',
                },
                {
                    name: 'textColor',
                    type: 'color',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubImageHeroProps> = {
    component: BusinessHubImageHero,
    config: BusinessHubImageHeroBuilderConfig,
};

export default builderConfig;
